var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/ResourcesMenu.js",
  _this = this;
import React, { useContext } from 'react';
import { List } from '@sm/wds-react';
import { SubMenuLink } from './components/SubMenuLink';
import { SeeMoreLink } from './components/SeeMoreLink';
import { resources, blog, helpCenter, exploreSurveyTemplates } from '../../config/linkInfo.js';
import SMHeaderContext from '../../SMHeaderContext';
export var ResourcesMenu = function ResourcesMenu() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  var isEnglish = ['en', 'en-gb'].includes(lang);
  return /*#__PURE__*/React.createElement(List, {
    interactive: true,
    transparent: true,
    noRules: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, isEnglish ? /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, resources(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 20
    }
  })) : null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, blog(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, helpCenter(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  })), isEnglish ? /*#__PURE__*/React.createElement(SeeMoreLink, Object.assign({}, exploreSurveyTemplates(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 20
    }
  })) : null);
};
export default ResourcesMenu;
//# sourceMappingURL=ResourcesMenu.js.map